exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-white-gradient[data-v-26d70e78] {\n  background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);\n}\n.bg-black-gradient[data-v-26d70e78] {\n  background: linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 20%, rgba(0, 0, 0, 0) 100%);\n}", ""]);

// exports
